import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addTags,
  deleteTags,
  getTags,
  updateTags,
} from "store/services/dataManagement/tags";

import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetAllTags = createAsyncThunk(
  "tags/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getTags(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const AddTagsAction = createAsyncThunk(
  "tags/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await addTags(rest);

      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        dispatch(GetAllTags());
        if (onSuccess) onSuccess();
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      if (onError) onError();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const UpdateTagsAction = createAsyncThunk(
  "tags/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;

    try {
      const res = await updateTags(rest);

      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        dispatch(GetAllTags());

        if (onSuccess) onSuccess();

        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      if (onError) onError();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const DeleteTagsAction = createAsyncThunk(
  "tags/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteTags(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(closeAdminModal());
        dispatch(GetAllTags());
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
